import {orderBy} from 'external/lodash'
import {
   clsx
  ,Fade
  ,List 
  ,ListItem 
  ,ListItemText 
  ,ListItemIcon 
  ,FiberManualRecordIcon 
} from 'external/material'
import useSession from 'hooks/session'
import useCatalog from 'hooks/catalog'
import LessonLinks from 'components/MyCourses/LessonLinks'

export default function UnitDetails({id}) {
  const {groupId} = useSession() 
  const {unitLessons = {}, isDownloaded} = useCatalog()
  const {course, lessons = [], content = {}} = unitLessons[id] || {}
  const lessonsLoaded = course == groupId && lessons.length > 0 
  return (<Fade in={lessonsLoaded}>
    <List className="lessons">
      {orderBy(lessons, ['id']).map(lesson => {
        const scheduled = content[lesson.id]
        const downloaded = isDownloaded({id: lesson.id, hash: lesson.hash})
        const events = scheduled && scheduled.map(({event}) => event)
        return (<ListItem className={clsx("lesson", {scheduled})} key={lesson.id} secondaryAction= {<LessonLinks {...{...lesson, scheduled, downloaded, events}} />}>
          <ListItemIcon className={clsx("lessonIcon", {scheduled})}><FiberManualRecordIcon /></ListItemIcon>
          <ListItemText className={clsx("lessonName", {scheduled})}>{lesson.id}: {lesson.name}</ListItemText>
          </ListItem>)
      })}
    </List>
  </Fade>)
}
